<template>
  <div class="row">
    <div
      v-for="emp in empilhadeiras"
      :key="emp.nr_placa"
      class="col-lg-3 col-md-6 col-sm-12 mb-4"
    >
      <div class="small-box bg-dark text-white p-3 rounded">
        <div class="inner">
          <div class="row mb-2">
            <div class="col text-left">
              <span class="badge bg-secondary">CHASSI</span>
            </div>
            <div class="col text-right">
              <small>{{ emp.nr_chassi }}</small>
            </div>
          </div>

          <div class="text-center">
            <h4 class="mb-2">
              <i></i> {{ emp.nr_placa }}
            </h4>
            <small>{{ emp.ds_tipoveiculo }}</small>
          </div>

          <hr />
          <div class="text-center">
            <span
              v-if="statusMap[emp.nr_chassi] && statusMap[emp.nr_chassi].statusReq === 'failure'"
              class="text-warning"
            >
              ERRO AO BUSCAR STATUS, É PROVÁVEL QUE A MÁQUINA NÃO ESTEJA CADASTRADA NA SMARTLIFT
            </span>

            <span
              v-else-if="statusMap[emp.nr_chassi] && statusMap[emp.nr_chassi].statusReq === 'success' && statusMap[emp.nr_chassi].status === '2'"
              class="text-success"
            >
              DESBLOQUEADO
            </span>

            <span
              v-else-if="statusMap[emp.nr_chassi] && statusMap[emp.nr_chassi].statusReq === 'success' && statusMap[emp.nr_chassi].status === '1'"
              class="text-danger"
            >
              BLOQUEADO
            </span>

            <span v-else>-</span>
          </div>
        </div>

        <a v-if="statusMap[emp.nr_chassi] && statusMap[emp.nr_chassi].statusReq === 'success' && statusMap[emp.nr_chassi].status === '1'" 
          class="small-box-footer text-lg bg-success mt-3 rounded" style="cursor: pointer;"  @click="verificarStatus(emp, type='2')"
        >
          Desbloquear <i class="fas fa-arrow-circle-right"></i>
        </a>

        <a v-else-if="statusMap[emp.nr_chassi] && statusMap[emp.nr_chassi].statusReq === 'success' && statusMap[emp.nr_chassi].status === '2'" 
          class="small-box-footer text-lg bg-danger mt-3 rounded" style="cursor: pointer;"  @click="verificarStatus(emp, type='1')"
        >
          Bloquear <i class="fas fa-arrow-circle-right"></i>
        </a>

        <a v-else 
          class="small-box-footer text-lg bg-primary mt-3 rounded" style="cursor: pointer;"  @click="verificarStatus(emp, type='3')"
        >
          Verificar Status <i class="fas fa-arrow-circle-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    empilhadeiras: {
      type: Array,
      required: true
    },

    keyApi: {
      type: String,
      default: ''
    }

  },

  data() {
    return {
      statusMap: {}
    };
  },

  methods: {
    async verificarStatus(emp, type) {
      try {
        const response = await fetch(
          `https://geomov.com/apiserver/webapi/wsrest/remoterestrictionforklift?geokey=${this.keyApi}&serial=${emp.nr_chassi}&type=${type}`
        );
        const data = await response.json();

        const status = data.machine.status;
        const statusReq = data.status;

        this.$set(this.statusMap, emp.nr_chassi, {
          status: status,        // "1" bloqueado ou "2" desbloqueado
          statusReq: statusReq   // "success" ou "failure"
        });
      } catch (error) {
        console.error(error);
        alert('Erro na requisição');
      }
    }
  },
}
</script>
